import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  Typography,
  Form,
  Input,
  // Select,
  Row,
  Col,
  Button,
  message,
  Spin,
  Switch,
  Select,
  Modal,
} from "antd";

import {
  BackwardOutlined,
  FormOutlined,
  RetweetOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import {
  capitalizeWords,
  formatDateWithSuffix,
} from "../../../../components/icons/ApplicationColor";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../api/Axios";
import {
  CUSTOMER_ID_FIELD,
  CUSTOMER_NAME_FIELD,
  FormInput,
} from "../../CAAdminCoursePages/courseForm";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";

import { PatternFormat } from "react-number-format";
import ParentTable from "../../../../components/AdminComponents/Modals/ParentTable";
import { setFirstTable } from "../../../../store/slices/firstTable";
const { Title, Paragraph } = Typography;
const { Item } = Form;


const { Option } = Select;
const Summary = ({ data1, loading, LoadUser, ImpersonateAccess, canEdit }) => {
  console.log(data1);
  const history = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const userInfo = useSelector((state) => state.user);
  const classification = useSelector(
    (state) => state.orgdeatil.customerClassification
  );
  const brokerName = useSelector((state) => state.orgdeatil.brokerName);
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [top, setTop] = useState(false);
  const [hierarchyData, setHierarchyData] = useState([]);
  const [labelEditModal, setLabelEditModal] = useState(false);
  const [active, setActive] = useState(true);


  const handleEditLabelModal = () => {
    setLabelEditModal(true);
  };

  const handleCancel = () => {
    setLabelEditModal(false);
  };

  const fetchHierarchyData = async () => {
    try {
      const response = await axiosInstance.get(
        `/customer/orgstructure/?organization_id=${id}&page=1&page_size=10&status=${active ? "True" : "False"}`
      );
      setHierarchyData(response.data.results);
    } catch (error) {
      console.error("Error fetching hierarchy data:", error);
    }
  };
  useEffect(() => {
    if (id) {
      fetchHierarchyData();
    }
  }, [id, active]);

  useEffect(() => {
    if (hierarchyData?.length > 0) {
      dispatch(setFirstTable({ length: hierarchyData.length, value: false }));
    }
  }, [dispatch, hierarchyData]);

  // const [tags, setTags] = useState([]);
  const [form] = Form.useForm();
  const [relationshipOptions, setRelationshipOptions] = useState([]);
  const CreateSuccessfull = (id) => {
    messageApi.open({
      type: "success",
      content: `${classification ? capitalizeWords(classification) : "Customer"} edit success.`,
      duration: 5,
    });
    LoadUser();
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: `${classification ? capitalizeWords(classification) : "Customer"} edit failure`,
      duration: 5,
    });
  };
  const formRef = useRef();
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const fetchRelationships = async () => {
    try {
      const orgId = userInfo?.data?.organization?.id;
      if (orgId) {
        const res = await axiosInstance.get(
          `accountrelationshiplist/?page=1&page_size=15&organization=${orgId}`
        );
        setRelationshipOptions(res.data?.results || []);
      }
    } catch (error) {
      console.error("Error fetching relationships:", error);
    }
  };

  useEffect(() => {
    fetchRelationships();
  }, [userInfo?.data?.organization?.id]);

  // Merge customer's existing account_relationships into options if not present
  useEffect(() => {
    if (data1?.account_relationships?.length > 0) {
      const existingRelationship = data1.account_relationships[0];
      setRelationshipOptions((prevOptions) => {
        // Check if the relationship already exists in options
        const exists = prevOptions.some((opt) => opt.id === existingRelationship.id);
        if (!exists && existingRelationship.id) {
          return [...prevOptions, existingRelationship];
        }
        return prevOptions;
      });
    }
  }, [data1?.account_relationships]);

  const handleInsurerNameChange = (value) => {
    form.setFieldsValue({ insurer_id: value });
  };

  const handleInsurerIdChange = (value) => {
    form.setFieldsValue({ insurer_name: value });
  };


  const handleSubmit = async (values) => {
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    const { deactivate_on, due_date, description, insurer_name, insurer_id, ...rest } = normalizedValues;

    const finalValues = {
      ...rest,

      parent_key: userInfo?.data?.organization?.id,
      account_relationship_id: insurer_name,
    };

    console.log("Form submitted with values:", finalValues);
    try {
      const res = await axiosInstance.put(
        `customer/customers/?id=${id}`,
        finalValues,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      CreateSuccessfull(res.data.id);
    } catch (err) {
      CreateFailed();
    }
  };
  const loadForm = React.useCallback(() => {
    if (!loading && formRef.current) {
      // Find the matching relationship ID from the account_relationships array
      const accountRelationshipId = data1?.account_relationships?.[0]?.id;

      const formValues = {
        name: data1?.name,
        client_id: data1?.client_id,
        description: data1?.description,
        address: data1?.address || "",
        industry: data1?.industry,
        zipcode: data1?.zipcode,
        city: data1?.city,
        enrollment_type: data1?.enrollment_type,
        org_type: data1?.org_type,
        ein: data1?.ein,
        state: data1?.state || "",
        country: data1?.country || "",
        access: data1?.access || false,
        insurer_name: accountRelationshipId,
        insurer_id: accountRelationshipId,
      };
      setSelectedCountry(data1?.country || "");
      setSelectedState(data1?.state || "");
      formRef.current.setFieldsValue(formValues);
    }
  }, [loading, data1, relationshipOptions]);

  const handleReset = () => {
    loadForm();
  };
  useEffect(() => {
    if (!loading && formRef.current) {
      loadForm();
    }
  }, [loading, data1, loadForm, relationshipOptions]);
  return (
    <Card
      style={{
        width: "100%",
        marginBottom: "10px",
      }}
      hoverable
    >
      <Spin spinning={loading}>
        {contextHolder}
        <Title level={4} style={{ letterSpacing: "0.5px" }}>
          {classification ? capitalizeWords(classification) : "Customer"}{" "}
          Information
        </Title>
        <Paragraph type="secondary">
          Edit and configure your existing{" "}
          {classification ? capitalizeWords(classification) : "Customer"} with
          the details below
        </Paragraph>

        <Form
          layout="vertical"
          onFinish={handleSubmit}
          name="complex-form"
          form={form}
          ref={formRef}
        //   onValuesChange={(_, allValues) => setFormValues(allValues)}
        >
          <Row gutter={16}>
            <FormInput
              field={{
                ...CUSTOMER_NAME_FIELD,
                span: 12,
                label: classification
                  ? `${capitalizeWords(classification)} Name`
                  : CUSTOMER_NAME_FIELD.label,
                placeholder: classification
                  ? `Enter ${capitalizeWords(classification)} name`
                  : CUSTOMER_NAME_FIELD.placeholder,
                rules: CUSTOMER_NAME_FIELD.rules.map((rule) => ({
                  ...rule,
                  message: classification
                    ? rule.message?.replace(
                      "Customer",
                      capitalizeWords(classification)
                    )
                    : rule.message,
                })),
                disabled: canEdit === false,
              }}
            />
            <FormInput
              field={{
                ...CUSTOMER_ID_FIELD,
                span: 12,
                label: classification
                  ? `${capitalizeWords(classification)} ID`
                  : CUSTOMER_ID_FIELD.label,
                placeholder: classification
                  ? `Enter ${capitalizeWords(classification)} ID`
                  : CUSTOMER_ID_FIELD.placeholder,
                rules: CUSTOMER_ID_FIELD.rules.map((rule) => ({
                  ...rule,
                  message: classification
                    ? rule.message?.replace(
                      "Customer",
                      capitalizeWords(classification)
                    )
                    : rule.message,
                })),
                disabled: canEdit === false,
              }}
            />
          </Row>

          {relationshipOptions.length > 0 && (
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label={`${brokerName || "Insurer"} Name`} name="insurer_name">
                  <Select
                    placeholder={`Select ${brokerName || "Insurer"} Name`}
                    onChange={handleInsurerNameChange}
                    disabled={canEdit === false}
                  >
                    {relationshipOptions.map((opt) => (
                      <Option key={opt.id} value={opt.id}>
                        {opt.insurer_name || opt.account_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label={`${brokerName || "Insurer"} ID`} name="insurer_id">
                  <Select
                    placeholder={`Select ${brokerName || "Insurer"} ID`}
                    onChange={handleInsurerIdChange}
                    disabled={canEdit === false}
                  >
                    {relationshipOptions.map((opt) => (
                      <Option key={opt.id} value={opt.id}>
                        {opt.insurer_id || opt.account_id}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row gutter={20}>
            <Col span={8}>
              <Form.Item label="Country">
                <Input.Group compact>
                  <Form.Item name="country" noStyle>
                    <CountryDropdown
                      // countryValueType="short"
                      //   disabled={!updateAuth}
                      value={selectedCountry}
                      onChange={(val) => setSelectedCountry(val)}
                      disabled={canEdit === false}
                      //   placeholder="Select County"
                      className="my-form-input-antd-test"
                      style={{
                        height: "3rem",
                        border: "0.1rem solid gray",
                      }}
                    />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="State">
                <Input.Group compact>
                  <Form.Item name="state" noStyle>
                    <RegionDropdown
                      // countryValueType="short"
                      //   disabled={!updateAuth}
                      country={selectedCountry}
                      value={selectedState}
                      onChange={(val) => setSelectedState(val)}
                      disabled={canEdit === false}
                      className="my-form-input-antd-test"
                      style={{
                        height: "3rem",
                        border: "0.1rem solid gray",
                      }}
                    />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="City" name="city">
                <Input placeholder="Enter City" disabled={canEdit === false} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={20}>
            <Col span={8}>
              <Form.Item
                name="zipcode"
                label="ZIP/Postal Code"
                rules={[
                  {
                    pattern:
                      selectedCountry === "United Kingdom"
                        ? /^[0-9a-zA-Z]*$/
                        : /^[0-9]*$/,
                    message:
                      selectedCountry === "United Kingdom"
                        ? "Please enter valid characters only"
                        : "Please enter numbers only",
                  },
                  {
                    min:
                      selectedCountry === "United States" ||
                        selectedCountry === "India" ||
                        selectedCountry === "United Kingdom" ||
                        selectedCountry === ""
                        ? 5
                        : undefined,
                    max:
                      selectedCountry === ""
                        ? 5
                        : selectedCountry === "United States"
                          ? 5
                          : selectedCountry === "India"
                            ? 6
                            : selectedCountry === "United Kingdom"
                              ? 7
                              : undefined,
                    message: "Invalid postal code",
                  },
                ]}
              >
                <Input placeholder="zip code" disabled={canEdit === false} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="EIN/Tax ID">
                <Form.Item
                  name="ein"
                  noStyle
                  rules={[
                    {
                      pattern: /^\d{2}-\d{7}$/,
                      message: "EIN format req xx-xxxxxxx",
                    },
                  ]}
                >
                  <PatternFormat
                    disabled={canEdit === false}
                    format="##-#######"
                    className="my-form-input-antd-test"
                    style={{
                      paddingTop: "0.57rem",
                      paddingBottom: "0.57rem",
                      paddingLeft: "0.7rem",
                      borderRadius: "0.5rem",
                      border: "0.1rem solid gray",
                    }}
                    placeholder={" xx-xxxxxxx"}
                  />
                </Form.Item>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Industry" name="industry">
                <Input
                  placeholder={`Enter ${classification ? capitalizeWords(classification) : "Customer"} Industry`}
                  disabled={canEdit === false}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label={`${classification ? capitalizeWords(classification) : "Customer"} Type`}
                name="org_type"
              >
                <Select placeholder="Select Type" disabled={canEdit === false}>
                  <Option value="non-profit">Non Profit</Option>
                  <Option value="profit">Profit</Option>
                  <Option value="Local Government">Local Government</Option>
                  <Option value="Individual">Individual</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Enrollment Type" name="enrollment_type">
                <Select placeholder="Select Enrollment Type" disabled={canEdit === false}>
                  <Option value="Organization">Organization</Option>
                  <Option value="Individual Instructor">
                    Individual Instructor
                  </Option>
                  <Option value="Training Company">Training Company</Option>
                  <Option value="Consultant Company">Consultant Company</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Address" name="address">
                <Input
                  placeholder={`Enter ${classification ? classification.toLowerCase() : "customer"}'s address`}
                  disabled={canEdit === false}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label="Portal Access"
                name="access"
                valuePropName="checked"
              >
                <Switch checkedChildren="Yes" unCheckedChildren="No" disabled={canEdit === false} />
              </Form.Item>
            </Col>
          </Row>
          {" "}{false &&
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label={`${classification ? capitalizeWords(classification) : "Customer"} Description`}
                  name="description"
                >
                  <Input.TextArea rows={4} placeholder="Enter description" />
                </Form.Item>
              </Col>
            </Row>
          }
        </Form>
        <div style={{ marginTop: "2rem" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <Title level={4} style={{ letterSpacing: "0.5px", margin: 0 }}>
              HIERARCHY
            </Title>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <Switch
                style={{
                  backgroundColor: active ? "#50C878" : "#FF0000",
                  minWidth: "90px",
                }}
                checked={active}
                onChange={(checked) => setActive(checked)}
                disabled={loading}
                checkedChildren="ACTIVE"
                unCheckedChildren="INACTIVE"
              />
              {/* <Button
                type="primary"
                className="save-update-btn"
                loading={loading}
                onClick={handleEditLabelModal}
              >
                Edit level Labels
              </Button> */}
            </div>
          </div>
          <div className="antd-test">
            <ParentTable
              isCustomerSummary={true}
              organizationId={id}
              refreshData={fetchHierarchyData}
              top={top}
              setTop={setTop}
              data={hierarchyData}
              active={active}
              CreateSuccessfull={() => {}}
              CreateFailed={() => {}}
              manager={[]}
              managerL2={[]}
              managerL3={[]}
            />
          </div>
        </div>
        <div
          className="group-1-box"
          style={{
            paddingTop: "0rem",
            paddingLeft: "0px",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <div>
            <div style={{ display: "inline-block" }}>
              <Form.Item label=" " colon={false}>
                <Button
                  type="text"
                  htmlType="button"
                  style={{
                    background: "#D3D3D3",
                  }}
                  onClick={() => {
                    history(
                      isCAAdmin
                        ? "/ca-admin/trainery-learn/bundles/listing"
                        : "/trainery-learn/courses/listing"
                    );
                  }}
                >
                  <BackwardOutlined />
                  Back
                </Button>
              </Form.Item>
            </div>

            <div style={{ display: "inline-block", marginLeft: "16px" }}>
              <Form.Item label=" " colon={false} shouldUpdate>
                {() => (
                  <Button
                    type="primary"
                    className="save-update-btn"
                    loading={loading}
                    disabled={
                      canEdit === false ||
                      form.getFieldsError().some(({ errors }) => errors.length > 0)
                    }
                    onClick={() => form.submit()}
                  >
                    Update
                    <FormOutlined />
                  </Button>
                )}
              </Form.Item>
            </div>
            <div style={{ display: "inline-block", marginLeft: "16px" }}>
              <Form.Item label=" " colon={false}>
                <Button
                  type="text"
                  htmlType="button"
                  onClick={handleReset}
                  disabled={canEdit === false}
                  style={{
                    background: "#D3D3D3",
                  }}
                >
                  Reset
                  <RetweetOutlined />
                </Button>
              </Form.Item>
            </div>
          </div>
        </div>
      </Spin>
      <Modal
        title={<p className="modal-heading">EDIT LEVEL LABELS</p>}
        centered
        onOk={handleEditLabelModal}
        onCancel={handleCancel}
        open={labelEditModal}
        footer={[]}
      >
        <Form
          //onFinish={onFinish2}
          style={{ marginTop: "3rem" }}
        //ref={formRef2}
        >
          <Item
            initialValue={''}
            label={
              <p
                className="modal-text"
                style={{
                  fontSize: "1.6rem",
                  minWidth: "14rem",
                  textAlign: "start",
                }}
              >
                TOP LEVEL
              </p>
            }
            name="entity_label"
          // rules={[
          //   { required: true, message: "Please input a Hirearcy name" },
          // ]}
          >
            <Input
              placeholder="Enter Top Level"
              initialValue={''}
            />
          </Item>
          <Item
            initialValue={''}
            label={
              <p
                className="modal-text"
                style={{
                  fontSize: "1.6rem",
                  minWidth: "14rem",
                  textAlign: "start",
                }}
              >
                MIDDLE LEVEL
              </p>
            }
            name="div_label"
          // rules={[
          //   { required: true, message: "Please input a hirearcy ID" },
          //   {
          //     max: 100,
          //     message: "Title should not exceed 100 characters",
          //   },
          // ]}
          >
            <Input
              placeholder="Enter Middle level"
              initialValue=''
            />
          </Item>
          <Item
            initialValue=''
            label={
              <p
                className="modal-text"
                style={{
                  fontSize: "1.6rem",
                  minWidth: "14rem",
                  textAlign: "start",
                }}
              >
                BOTTOM LEVEL
              </p>
            }
            name="dep_label"
          >
            <Input
              placeholder="Enter Bottom level"
              initialValue=''
            />
          </Item>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              height: "2rem",
              marginTop: "1rem",
              marginBottom: "1rem",
            }}
          >
            <Form.Item style={{ marginRight: "1rem" }}>
              <Button key="back" onClick={handleCancel}>
                <CloseOutlined />
                Cancel
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  background: "#f58029",
                  fontWeight: "600",
                }}
                className="save-update-btn"
              >
                Update
                <FormOutlined />
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </Card>
  );
};

export default Summary;
